import { UniversalFilterConfig } from "../../components/Tables/universalRecord/UniversalFilterBar";

export const buildDocumentSequenceFilters = (
  branchDropdown: { id: number; name: string }[],
  documentTypeDropdown: { id: number; name: string }[]
): UniversalFilterConfig[] => [
  {
    name: "branchId",
    label: "Sucursal",
    type: "searchSelect",
    iconKey: "branch",
    options: branchDropdown.map((b) => ({ id: b.id, name: b.name })),
  },
  {
    name: "documentTypeId",
    label: "Tipo de Documento",
    type: "searchSelect",
    iconKey: "document",
    options: documentTypeDropdown.map((d) => ({ id: d.id, name: d.name })),
  },
];
